/**
 * All backend environments.
 *
 * 'local' indicates that you are running the backend locally
 */
export const environments = ['prod', 'local', 'dev01', 'dev02', 'dev03', 'dev04', 'plt03', 'qa03'] as const
export type EnvironmentName = (typeof environments)[number]
